import { initMap, equalCols, getCookie } from '../functions';
import Swal from 'sweetalert2'

$(document).ready(function() {

	const eventTickets = {
        isLoading: false,
        init() {
            $(document).on('click', '.event-ticket-confirm-btn', this, this.confirm);
        },
		confirm(event) {
			const _this = event.data;
			event.preventDefault();

			let id = $(this).data('id');

			if (_this.isLoading) {
                return false;
            }

            $('.ticket-confirm-form').find('.form-control').removeClass('is-invalid');
            $('#ticket-confirm-terms').removeClass('is-invalid');

            var error = false;
            if ($('#ticket-confirm-name').val() == '') {
                $('#ticket-confirm-name').addClass('is-invalid');
                error = true;
            }
            if ($('#ticket-confirm-email').val() == '') {
                $('#ticket-confirm-email').addClass('is-invalid');
                error = true;
            }
            if (!$('#ticket-confirm-terms').is(":checked")) {
				$('#ticket-confirm-terms').addClass('is-invalid');
				error = true;
			}

            if (error) {
                return false;
            }

			//Loading...
            _this.isLoading = true;
			let element = this;
			$(element).find('i').show();

			var values='';
            values+='id=' + id;
            values+='&name=' + $('#ticket-confirm-name').val();
            values+='&email=' + $('#ticket-confirm-email').val();
            values+='&phone=' + $('#ticket-confirm-phone').val();
            values+='&_token=' + $('meta[name="csrf-token"]').attr("content");
			$.ajax({
                type: "POST",
                url: baseURLlang + 'ticket/confirm',
                data: values,
                success: function(response) {
					_this.isLoading = false;
					$(element).find('i').hide();

					if (response.status == 1) {
                        $('#ticket-confirm-terms').prop('checked', false);
                        $('.ticket-confirm-form').find('.form-control').val('');

						Swal.fire({
							// icon: 'success',
							// title: 'Success!',
							html: response.message
						});

						return false;
					}

                    Swal.fire({
                        // icon: 'error',
                        // title: 'Error!',
                        html: response.message
                    });
	            },
                error(error) {
                    _this.isLoading = false;
					$(element).find('i').hide();
                },
	        });
		}
    };

    if ($('.event-ticket-confirm-btn').length) {
        eventTickets.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/tickets.js